module.exports = __webpack_public_path__ + "static/media/steem.855d4357.svg";